import React from "react"
import { Button, Container, Row, Col } from "react-bootstrap"
import { GiCurlyWing } from "react-icons/gi"
import Image from "@src/utils/image"
import Text from "../utils/text"
import { Link } from "gatsby"

const Header = () => {
  return (
    <Container className="header">
      <Row className="align-items-center py-6">
        <Col md={5} className="px-4 mb-3 mb-md-0">
          <Image id="6sUL2VA93eCHRBEKsHwjIa" />
        </Col>

        <Col>
          <Text id="7BagKBA5X2U4lOJwlivhM6" />

          <Link to="/contact">
            <Button variant="powder" size="lg" className="header-button">
              <span className="px-2">Book a consultation!</span>
            </Button>
          </Link>
        </Col>
      </Row>
    </Container>
  )
}

export default Header
